import React, { useState } from "react";
import ButtonComponent from "../../../components/ButtonComponent";
import { Input } from "../../../components/Input";
import { useForm } from "react-hook-form";
import { COLORS } from "../../../lib/colors";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import * as HTTPServices from "../../../api/HTTPServices";
import { useUserState } from "../../../providers/UserProvider";
import classes from "./index.module.scss";
import { useTranslation } from "react-i18next";

function Index() {
  const { t } = useTranslation();
  const user = useUserState();
  const { register, handleSubmit } = useForm();

  // const [redirect, setRedirect] = useState(false);
  // const [redirectLink, setRedirectLink] = useState("");
  const [value, setValue] = useState("refundAllRequest");
  const [amount, setAmount] = useState();

  const onSubmit = (data) => {
    console.log(`data`, data);
    try {
      let params = new FormData();
      if (value === "refundAllRequest") {
        params.append("amount", user.UserLogin.credit);
      } else if (value === "refundPartlyRequest" && amount !== undefined) {
        if (amount === "0") {
          // setLoading(false);
          // Helper.ErrorData("as");
          return;
        } else if (Number(amount) > user.UserLogin.credit) {
          // setLoading(false);
          // Helper.ErrorData("asas");
          return;
        } else if (Number(amount) < 50000) {
          // setLoading(false);
          // Helper.ErrorData("asas");
          return;
        } else if (amount.toUpperCase() !== amount.toLowerCase()) {
          // setLoading(false);
          // Helper.ErrorData("Do not insert letters");
          return;
        } else {
          params.append("amount", amount);
        }
      } else if (Number(amount) === undefined) {
        // setLoading(false);
        // Helper.ErrorData("Do not insert letters");
        return;
      } else {
        params.append("amount", amount);
      }
      const RequestService = HTTPServices.postMethod(
        "user_refund",
        params,
        "true"
      );
      RequestService.then(function (response) {
        if (response) {
          console.log(`response`, response);
          // setLoading(false);
          // Helper.SuccessData(response.message);
        }
      });
    } catch (error) {
      // setLoading(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleChangeAmount = (event) => {
    if (event.target.value === "e") {
      event.preventDefault();
    }
    let value = event.target.value;
    value.replace(/[^0-9a-z]/gi, "");
    setAmount(value);
  };

  return (
    <div>
      <h3 className={classes.title}>
        {t("pages.protectedPages.withdrawalRequest.title")}
      </h3>
      <hr></hr>
      <div className={classes.formContainer}>
        <div className={classes.inerContainer}>
          <div>{t("pages.protectedPages.withdrawalRequest.credit")} 0</div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <RadioGroup
              className="canselType"
              aria-label="canselType"
              name="canselType"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="refundAllRequest"
                control={<Radio />}
                label={t("pages.protectedPages.withdrawalRequest.total")}
              />
              <FormControlLabel
                value="refundPartlyRequest"
                control={<Radio />}
                label={t("pages.protectedPages.withdrawalRequest.part")}
              />
            </RadioGroup>
            {value === "refundPartlyRequest" && (
              <div>
                <div>
                  <Input
                    autoFocus={true}
                    autoComplete="off"
                    id="price"
                    name="price"
                    type="number"
                    {...register("amount", { required: true })}
                    label={t("pages.protectedPages.withdrawalRequest.desire")}
                    value={amount}
                    onChange={handleChangeAmount}
                  />
                </div>
              </div>
            )}

            <div>
              <ButtonComponent
                width="100%"
                backgroundColor={COLORS.primary}
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {t("pages.protectedPages.withdrawalRequest.button")}
              </ButtonComponent>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Index;
